import { render, staticRenderFns } from "./QualificationForm.vue?vue&type=template&id=8ce473da&scoped=true&"
import script from "./QualificationForm.vue?vue&type=script&lang=js&"
export * from "./QualificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce473da",
  null
  
)

export default component.exports